import { removeDiacritics } from "./find";
import { stopwords } from "./nlp";

export const prepareKeywordList = (keywordsList?: string[]): string[] => {
  return (keywordsList ?? [])
    .filter((k) => !stopwords.has(k)) // TODO : not if it's a quoted string
    .map((k) => removeDiacritics(k.toLocaleLowerCase()));
};
